module.exports = __webpack_public_path__ + "static/media/miel-lapiquera-01.6789ae73.jpg";